import * as Scrivito from "scrivito";
import EventDate from "^/Components/Events/EventDate";

function EventData({ event, language }) {
  const location = event.get("locationCity");
  return (
    <div className="event-overview__event-node">
      <div className="row mx-0 event-overview__event-data">
        <div className="p-3 col-sm-4 bg-lighter-gray text-orange event-overview__event-node--date">
          <EventDate event={event} language={language} />
        </div>
        <div className="col-md-8 p-3">
          <Scrivito.ContentTag
            className="m-0 pb-2"
            attribute="title"
            content={event}
            tag="h5"
          />
          <EventLocation location={location} />
          <Scrivito.ContentTag
            content={event}
            attribute="description"
            className="pb-2"
          />
        </div>
      </div>
    </div>
  );
}

function EventLocation({ location }) {
  if (!location) {
    return null;
  }
  return (
    <div className="py-2 text-orange">
      <i className="las la-map-marker me-2" />
      {location}
    </div>
  );
}

export default Scrivito.connect(EventData);
